import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

type ManageWithdrawalsPayload = {
  withdrawalId: string;
  minAmount: number;
  maxAmount: number;
  requestingDayFrom: string;
  requestingDayTo: string;
  withdrawableDate: string;
};

export const manageWithdrawals = (client: AxiosInstance) => async (payload: ManageWithdrawalsPayload) => {
  return (
    await client.post<{ message: string; data: { categoryName: string; description: string; id: string } }>(
      API_ROUTES.MANAGE_WITHDRAWAL_SETUP,
      payload,
    )
  ).data;
};

export const withdrawalsMutations = {
  manageWithdrawals,
};
